<template>
  <v-dialog max-width="40%" v-model="dialog">
    <template #activator="{ on }">
      <v-btn v-on="on" icon>
        <v-icon>add</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title>
        Start Processing on a New Work Order
        <v-spacer />
        <v-btn icon><v-icon left>exit</v-icon></v-btn>
      </v-card-title>
      <v-card-subtitle>This Work Order must be chosen from the current Pipeline</v-card-subtitle>
      <v-card-text>
        <v-form>
          <v-select
            :items="inque"
            item-value="id"
            :item-text="item => item.workorder.forgeID + ` - ` + item.workorder.name"
            v-model="process_id"
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close">Close</v-btn>
        <v-btn text color="green" @click="submit" :loading="loading">Submit</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ToolProcess from "../../models/ToolProcess";
export default {
  name: "ToolProcessActiveAdd",
  props: {
    toolid: {
      type: [Number, String],
      required: true
    }
  },
  data() {
    return {
      process_id: null,
      loading: false,
      dialog: false
    }
  },
  computed: {
    inque() {
      return ToolProcess.query()
        .where("tool_id", parseInt(this.toolid))
        .where("in_que", true)
        .with("workorder")
        .orderBy("priority", "desc")
        .get();
    }
  },
  methods: {
    submit() {
      this.loading = true;
      ToolProcess
        .$patch(this.process_id, { in_que: false, in_process: true })
        .then(() => {
          this.loading = false;
          this.close();
        });
    },
    close() {
      this.dialog = false;
    }
  }
}
</script>
